import { ShowButton, TopToolbar, useGetIdentity, useRedirect } from 'react-admin'

const TextModelEditActions = () => {

  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <TopToolbar>
      <ShowButton onClick={(e) => {
        e.preventDefault()
        redirect(`/users/${identity.id}/textModel`)
      }}/>
    </TopToolbar>
  )
}

export default TextModelEditActions